import { breadcrumbTranslation, getHmiTabBreadcrumb } from 'components/layout/Breadcrumb/utils';
import { AssetBreadcrumb } from 'components/layout/DynamicBreadcrumbs/AssetBreadcrumb';
import { CreateReportBreadcrumb } from 'components/layout/DynamicBreadcrumbs/CreateReportBreadcrumb';
import { ProjectBreadcrumb } from 'components/layout/DynamicBreadcrumbs/ProjectBreadcrumb';
import { HmiLayout } from 'features/hmi/components/HmiLayout';
import { ProjectsTopbarLayout } from './ProjectsTopbarLayout';
import { ProjectMonitoringLayout } from './[Project]/Monitoring/Monitoring.layout';
import { ProjectLayout } from './[Project]/[Project].layout';

export const projectsOverviewRoutes = [
  {
    path: 'projects',
    breadcrumb: breadcrumbTranslation('projects'),
    element: <ProjectsTopbarLayout />,
    children: [
      {
        index: true,
        lazy: () => import('pages/Projects/CardView'),
      },
      {
        path: 'overview',
        breadcrumb: breadcrumbTranslation('projects-overview'),
        lazy: () => import('pages/Projects/Overview'),
      },
      {
        path: 'map',
        breadcrumb: breadcrumbTranslation('projects-map'),
        lazy: () => import('pages/Projects/MapView'),
      },
    ],
  },
];

export const newProjectRoute = {
  path: 'projects',
  breadcrumb: breadcrumbTranslation('projects'),
  children: [
    {
      path: 'new',
      breadcrumb: breadcrumbTranslation('projects-new'),
      lazy: () => import('pages/Projects/New'),
    },
  ],
};

export const projectsRoutes = [
  {
    path: 'projects',
    breadcrumb: breadcrumbTranslation('projects'),
    children: [
      {
        path: ':projectSlug',
        element: <ProjectLayout />,
        children: [
          {
            index: true,
            breadcrumb: ProjectBreadcrumb,
            lazy: () => import('pages/Projects/[Project]'),
          },
          {
            path: 'administration',
            breadcrumb: breadcrumbTranslation('projects-administration'),
            lazy: () => import('pages/Projects/[Project]/Administration'),
          },
          {
            path: 'setups',
            breadcrumb: breadcrumbTranslation('projects-setups'),
            lazy: () => import('pages/Projects/[Project]/Setups'),
          },
          {
            path: 'analytics',
            breadcrumb: null,
            children: [
              {
                path: 'reports',
                breadcrumb: breadcrumbTranslation('projects-analytics-reports'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports'),
              },
              {
                path: 'reports/new-report',
                breadcrumb: breadcrumbTranslation('projects-analytics-new-report'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports/NewReport'),
              },
              {
                path: 'reports/new-report/:microgridId',
                breadcrumb: CreateReportBreadcrumb,
                lazy: () => import('pages/Projects/[Project]/Analytics/Reports/NewReport/[Microgrid]'),
              },
              {
                path: 'summary',
                breadcrumb: breadcrumbTranslation('projects-analytics-summary'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Summary'),
              },
              {
                path: 'assets',
                breadcrumb: breadcrumbTranslation('projects-analytics-assets'),
                lazy: () => import('pages/Projects/[Project]/Analytics/Assets'),
              },
            ],
          },
          {
            path: 'monitoring',
            breadcrumb: null,
            element: <ProjectMonitoringLayout />,
            children: [
              {
                path: 'multi-battery-graphs/*',
                breadcrumb: breadcrumbTranslation('projects-monitoring-multi-battery-graphs'),
                lazy: () => import('pages/Projects/[Project]/Monitoring/MultiBatteryGraphs/MultiBatteryGraphs'),
              },
              {
                path: ':unitExternalIdentifier',
                breadcrumb: null,
                children: [
                  {
                    path: 'asset',
                    breadcrumb: breadcrumbTranslation('projects-monitoring-assets'),
                    lazy: () => import('pages/Assets/[Asset]'),
                  },
                  {
                    path: 'graphs',
                    breadcrumb: breadcrumbTranslation('projects-monitoring-graphs'),
                    lazy: () => import('pages/Assets/[Asset]/Graphs'),
                  },
                  {
                    breadcrumb: null,
                    element: <HmiLayout />,
                    children: [
                      {
                        path: 'hmi',
                        breadcrumb: AssetBreadcrumb,
                        lazy: () => import('features/hmi/components/HmiTabs'),
                      },
                      {
                        path: 'hmi/menu',
                        breadcrumb: null,
                        lazy: () => import('features/hmi/components/HmiMobileMenu'),
                      },
                      {
                        path: 'hmi/:tab',
                        breadcrumb: getHmiTabBreadcrumb('projects-monitoring-hmi'),
                        lazy: () => import('features/hmi/components/HmiTabs'),
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
